module.exports = __webpack_public_path__ + "static/img/deskbg.c275c193.jpg";